import device from 'current-device';
import {CookieService} from '../services/cookie.service';

export class DeviceCategoryDetector {
    static readonly NAME = 'user_device_category';
    public static saveDeviceInCookies(): void {
        if (device?.type) {
            CookieService.setCookie(DeviceCategoryDetector.NAME, device.type, 1);
        }
    }

    public static saveDeviceInStorage(): void {
        if (device?.type) {
            localStorage.setItem(DeviceCategoryDetector.NAME, device.type);
        }
    }

    public static checkIfCookieExists(): boolean {
        if (CookieService.getCookie(DeviceCategoryDetector.NAME)) {
            return true;
        }
        return false;
    }

    public static checkIfSavedInStorage(): boolean {
        if (localStorage.getItem(DeviceCategoryDetector.NAME)) {
            return true;
        }
        return false;
    }
}

window.addEventListener('load', () => {
    if (!DeviceCategoryDetector.checkIfCookieExists()) {
        DeviceCategoryDetector.saveDeviceInCookies();
    }
    if (localStorage && !DeviceCategoryDetector.checkIfSavedInStorage()) {
        DeviceCategoryDetector.saveDeviceInStorage();
    }
});
